import { getFramework } from '@/framework';
import { REFERENCE_LINE_DIRECTION } from '../constants';
import { getReferenceLinesState } from '../states/reference-lines-state';
import { ReferenceLineHistoryType, type ReferenceLine, type ReferenceLineDirection } from '../types';
import { genReferenceLineId, getDefaultReferenceLine } from '../utils';

export class AddReferenceLine {
    constructor(private id: string) {}

    add(direction: ReferenceLineDirection, pushHistory = true) {
        const framework = getFramework(this.id);
        const { edgelessCanvas } = framework.service;
        const scale = edgelessCanvas.zoom;
        const { width: viewWidth, height: viewHeight } = edgelessCanvas.getSize();

        let position = 0;
        if (direction === REFERENCE_LINE_DIRECTION.HORIZONTAL) {
            position = viewHeight / 2 - edgelessCanvas.translateY;
        } else {
            position = viewWidth / 2 - edgelessCanvas.translateX;
        }

        const newLine = {
            id: genReferenceLineId(),
            position: Math.round(position / scale),
            direction,
        };

        const result = this.addWithLineData(newLine, pushHistory);
        return result;
    }
    addWithLineData(line: Partial<ReferenceLine>, pushHistory = true) {
        const framework = getFramework(this.id);
        const result = getDefaultReferenceLine(line);
        getReferenceLinesState(this.id).addReferenceLine(result);
        getReferenceLinesState(this.id).setShowReferenceLines(true);

        // 写入历史记录
        if (pushHistory) {
            framework.service.history.write({
                type: ReferenceLineHistoryType.ADD,
                data: {
                    item: result,
                },
            });
        }

        return result;
    }
}
